import { ProjectorFn } from "./projectorFn";
import { ReplacerFn } from "./replacerFn";

export const PROPERTY_KEY_LOG_VALUES = "$logValues";
export interface LoggerParamMetadata
{
    name?: string | symbol;
     
    replacer?: ReplacerFn;
    project?: ProjectorFn;
}
